import React from 'react'
import withView from '../../cmn/docAutomation/withView';
import FormROValue from '../../../library/form/components/FormROValue1';
import FormInput from '../../../library/form/components/FormInput';
import FormLink from '../../../library/form/components/FormLink';
import FormLabel from '../../../library/form/components/FormLabel'
import FormRichText from '../../../library/form/components/FormRichText'
import FormDialog from '../../../library/form/components/FormDialog';
import FormTitle from '../../../library/form/components/FormTitle'
import FormSH from '../../../library/form/components/FormSH';

const InvTrnHeaderSH2 = (props) => {
    const { formObject, viewData, ...restProps } = props;

    if(!viewData)
        return(null)

    // console.log("View data", viewData);

    const shOptionData = formObject.getFormData("", "", "shOption")
    const shOption = shOptionData.val;

    return (
            <FormDialog onDynamicViewClose={restProps.onDynamicViewClose} enablePopup={true}
            action={{ formActions: { forAction: "Confirm", forCancel: "Cancel" }, actionParam:{showModeID:'sh',shOption:shOption} }}
            formStyle={{ width: '450px'}}
            contentStyle={{ height: '340px' }}
            formTitle={<FormTitle formObject={formObject} value='Main Detail' />}
            formObject={formObject} >

            <div className="uiEditableContent">
                <FormROValue formObject={formObject} rowKey="" action={{ paramName: "errorMsg" }} style={{color:"red"}} />
                <div className="uiRow">
                    <ul>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "profile1" }} value="" />
                            </span>
                            <FormLink formObject={formObject} rowKey=""
                                    action={{
                                        paramName: "profile1",
                                        actionId: "show",  
                                        containerKey: "popup"
                                    }}
                                    linkProp={{target: "_blank"}}
                                ></FormLink>

                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "profile2" }} value="ID" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" className="uiInput"
                                action={{ InputType: "ac", paramName: "profile2", acMethod: "ProfileName", acDepCtrl: { dparam: "%dataList.valLDT", reqPerm: 1 } }}
                            />
                            <FormSH formObject={formObject} rowKey="" 
                                action={{ actionId: "new", paramName: "profile2",  actionName: "proComp", actionParam: {}, containerKey: "popup" }}
                            ></FormSH>
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "address" }} value="Address" />
                            </span>
                            <FormRichText formObject={formObject} rowKey="" rows="2" cols="82" className="uiFrmText"
                                action={{ InputType: "ac", paramName: "address", acMethod:"ProfileAddress", acValidate: "0", acDepCtrl:{ dptid: "%dataList.valLDT", dpid: "#profile2" } }} 
                            />
                        </li>
                        <li> 
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "shInvDate" }} value="Document Date" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" id="relationSince" className="uiInput"
                                action={{ InputType: "dp", paramName: "shInvDate" }} />
                        </li>
                        <li id="amountContainer" >
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "shInvAmount" }} value="Amount" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" className="uiVal"
                                    action={{ InputType: "input", paramName: "shInvAmount" }}
                                />
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "currency" }} value="Currency" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" className=""
                                action={{ InputType: "ac", actionName: "invTrans", actionId:"refresh", paramName: "currency", acMethod: "CurrencyName", acDepCtrl: { 'dparam': "%dataList.valLCat" },actionParam:{updateCurrency:"1"} }}
                            />
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "exRate" }} value="Exchange Rate" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" className=""
                                action={{ InputType: "input", actionName: "invTrans", actionId:"refresh", paramName: "exRate", actionParam:{updateCurrency:"1"} }}
                            />
                            <span >
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "exRateHelper" }} value="" />
                            </span>
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "totalAmount" }} value="Total Amount" />
                            </span>
                            <FormROValue format="#.00" formObject={formObject} rowKey="" action={{ paramName: "totalAmount" }} />
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "convertedAmount" }} value="After Conversion" />
                            </span>
                            <FormROValue formObject={formObject} rowKey="" action={{ paramName: "convertedAmount" }} />
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "refExNo" }} value="Ref. No (Ex)" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" id="refExNotxt" className="uiInput"
                                action={{ InputType: "input", paramName: "refExNo" }} />
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "refExDate" }} value="Ref. Date (Ex)" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" className="" id="refExDatetxt"
                                action={{ InputType: "dp", paramName: "refExDate" }} />
                        </li>
                    </ul>
                </div>
            </div>
        </FormDialog>
    )
}

export default withView(InvTrnHeaderSH2, "invcomp", "invTrans,invTrnHeader,InvTrnFooter")